// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3fQfe","footer":"ModalError_footer__1rSRv"};